import useSWR from "swr";

import { type DocumentShare, type ShareTarget } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/documents";

export function useDocumentShares(documentId: number | undefined) {
  return useSWR<DocumentShare[], Error>(
    documentId ? `${url}/${documentId}/shares` : null,
    simpleFetcher,
  );
}

export function useShareTargets(documentId: number | undefined) {
  return useSWR<ShareTarget[], Error>(
    documentId ? `${url}/${documentId}/share-targets` : null,
    simpleFetcher,
  );
}
